import { useEffect, useState } from 'react';

import * as api from '../utils/api';
import { useAppDispatch } from '../redux/hooks';
import { setFollowCompanyList } from '../pages/Dashboard/BookmarkSlice';
import { setOpenPackageLimitModal } from '../components/PackageLimitModal/PackageLimitModalSlice';

const useInvestmentCategories = () => {
  const dispatch = useAppDispatch();
  const [isOpeningBookmark, setIsOpeningBookmark] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [investmentCategories, setInvestmentCategories] = useState([]);
  const [followCompanies, setFollowCompanies] = useState([]);
  const [
    investmentCategoriesMessage,
    setInvestmentCategoriesMessage,
  ] = useState({
    message: ``,
    showMessage: false,
    isError: false,
  });

  const getAccount = async () => {
    try {
      const { data } = await api.get(`/user/me`);
      if (data) {
        setAuthenticated(true);
        getInvestmentCategories();
        getFollowCompanies();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSetIsOpeningBookmark = (value) => {
    setIsOpeningBookmark(value);
  };

  const getInvestmentCategories = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get(`/investment-category/get-all-category`);
      setInvestmentCategories(data);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const getFollowCompanies = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get(`/follow-company/get-all-follow-company`);
      setFollowCompanies(data);
      dispatch(setFollowCompanyList(data));
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const saveInvestmentCategory = async (investmentCategoryId, machungkhoan) => {
    setIsLoading(true);
    try {
      const { data } = await api.post(`/follow-company/create`, {
        investmentCategoryId,
        machungkhoan,
      });
      if (!data.status && data?.limit) {
        dispatch(setOpenPackageLimitModal());
        setIsLoading(false);
        return false;
      } else {
        setInvestmentCategoriesMessage({
          message: `Mã chứng khoán đã được thêm vào ${
            investmentCategories.find((e) => e.id == investmentCategoryId).name
          } để theo dõi.`,
          showMessage: true,
          isError: false,
        });
        await getFollowCompanies();
        setIsLoading(false);
        return true;
      }
    } catch (error) {
      setInvestmentCategoriesMessage({
        message: `Thêm mã chứng khoán bị lỗi. Xin thử lại`,
        showMessage: true,
        isError: true,
      });
      console.error(error);
      setIsLoading(false);
      return false;
    }
  };

  const deleteInvestmentCategory = async (
    investmentCategoryId,
    machungkhoan
  ) => {
    setIsLoading(true);
    try {
      await api.post(`/follow-company/delete-by-code`, {
        investmentCategoryId,
        machungkhoan,
      });
      setInvestmentCategoriesMessage({
        message: `Mã chứng khoán đã được xoá khỏi ${
          investmentCategories.find((e) => e.id == investmentCategoryId).name
        }`,
        showMessage: true,
        isError: false,
      });
      await getFollowCompanies();
    } catch (error) {
      setInvestmentCategoriesMessage({
        message: `Xoá mã chứng khoán bị lỗi. Xin thử lại`,
        showMessage: true,
        isError: true,
      });
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAccount();
  }, []);

  return {
    isLoading,
    authenticated,
    investmentCategories,
    followCompanies,
    saveInvestmentCategory,
    deleteInvestmentCategory,
    investmentCategoriesMessage,
    isOpeningBookmark,
    handleSetIsOpeningBookmark,
    getInvestmentCategories,
    getFollowCompanies,
  };
};

export default useInvestmentCategories;
